var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mic",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.166,
    height: 62.318,
    viewBox: "0 0 40.166 62.318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M131.166,255h-3.651a16.431,16.431,0,0,1-32.863,0H91a20.11,20.11,0,0,0,18.257,20v7.63H96.477v3.651h29.211v-3.651h-12.78V275A20.11,20.11,0,0,0,131.166,255Z",
    transform: "translate(-91 -223.963)",
    fill: "#3e3e3e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M163.78,43.817a12.8,12.8,0,0,0,12.78-12.78V12.78a12.78,12.78,0,0,0-25.56,0V31.037A12.8,12.8,0,0,0,163.78,43.817Zm0-40.166a9.144,9.144,0,0,1,8.945,7.3h-5.293v3.651h5.477v5.477h-5.477v3.651h5.477v5.477h-5.477v3.651h5.293a9.13,9.13,0,0,1-17.89,0h5.293V29.211h-5.477V23.734h5.477V20.083h-5.477V14.606h5.477V10.954h-5.293A9.144,9.144,0,0,1,163.78,3.651Z",
    transform: "translate(-143.697)",
    fill: "#3e3e3e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.1c81ccc4cfd58598bac4c8d447b19126.svg";
export { ForwardRef as ReactComponent };